!(function (window, document, $) {

    $('#load-more-articles').on('click', function (evt) {
        evt.preventDefault();
        var btn = $(evt.target);

        $.get(evt.target.href)
            .done(function (html) {
                var nextUrl = $(html).filter('[data-pagination-next]').attr('data-pagination-next');
                $('#infinite-container').append(html);
                if (nextUrl) {
                    btn.attr('href', nextUrl)
                } else {
                    btn.remove();
                }
            })
            .fail(function () {
                btn.remove();
            });
    });

})(window, document, jQuery);